// extracted by mini-css-extract-plugin
export var active = "_l6-2";
export var recordingDot = "_l6-1";
export var recordingIndicator = "_l6-0";